<template>
    <div class="">
        <div class="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
            <div class="max-w-2x1 w-full">
                <div class="text-center">
                    <img class="mx-auto h-24 w-auto" src="../assets/img/logos/logo.png" alt="Workflow"/>
                    <h2 class="mt-6 text-center text-2xl leading-9 font-extrabold text-gray-900">
                        404 Page Not Found
                    </h2>
                    <h5 class="text-2xl ">Oops. The page you were looking for doesn't
                        exist.</h5>
                    <p class="tx-color-03 mb-6">You may have mistyped the address or the page may have moved.</p>
                    <div class="py-3">
                        <router-link to="/" class="bg-transparent hover:bg-indigo-800 text-indigo-700 font-semibold hover:text-white py-2 px-4 border border-indigo-500 hover:border-transparent rounded">
                            Go Home
                        </router-link>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'PageNotFound',
        components: {}
    }
</script>

<style>

</style>
